





























































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService, SkcServerService, SkcServerOrderService } from "src/services";
import { IServerModel, IServerOrderModel } from "src/model";
import router from '../../router';
import { ServiceType, DurationUnitType, ServerOrderStatusType } from "src/enums";
import { EnumUtils } from "src/utils";
import STable from "@/components/common/Table";
import XCard from "@/components/common/xnComponents/XCard.vue";
@Component({
    components: {
        XCard,
        STable
    }
})
export default class skcServerOrder extends Vue
{
    /**
     * 订单明细
     */
    protected dataJson: any = {};

     /**
     * 总金额
     */
    protected allPrice: number = 0;
    /**
     * 查询参数
     */
    protected queryParam: any = {};

    /**
     * 表头
     */
    protected columns: Array<any> = [
        {
            title: "订单名称",
            dataIndex: "serverRemark"
        },
        {
            title: "订单编号",
            dataIndex: "orderNo"
        },
        {
            title: "金额",
            dataIndex: "price"
        },
        {
            title: "下单时间",
            dataIndex: "createdTime"
        },
        {
            title: "有效期",
            dataIndex: "expiredTime"
        },
        {
            title: "订单状态",
            dataIndex: "status",
            scopedSlots: {
                customRender: "sexLimit"
            }
        },
        {
            title: "操作",
            width: "200px",
            dataIndex: "action",
            scopedSlots: {
                customRender: "action",
            }
        }
    ];

 /**
     * 加载数据方法
     */
    protected async loadData(parameter: any): Promise<any> {
        try {
            let { content: res } = await this.skcServerOrderService.skcServerOrderPageList(
                // Object.assign(parameter, this.queryParam, {serverType: 1, status: 1})
                Object.assign(parameter, this.queryParam, {serverType: 1})
            );
            this.dataJson = res.data.rows[0];
            this.allPrice = res.data.rows.reduce((total,item)=>{
                return total + item.price
            },0);
            return res.data;
        } catch (err) {
            console.log(err);
            this.$message.error("获取订单列表错误");
        }
    }

    /**
     * loading
     */
    protected loading: boolean = false;

    /**
     * 年限
     * @protected
     * @returns 
     */
    protected priceData: Array<any> = [
        {id: 0, name: '年', num: 1, checked: true},
        {id: 1, name: '二年', num: 2, checked: false},
        {id: 2, name: '三年', num: 3, checked: false}
    ];

    /**
     * 获取平台服务
     * @private
     * @return SkcServerOrderService
     */
    private _skcServerOrderService: SkcServerOrderService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerOrderService(): SkcServerOrderService
    {
        if(!this._skcServerOrderService)
        {
            this._skcServerOrderService = this.$serviceProvier.resolve<SkcServerOrderService>(SkcServerOrderService);
        }

        return this._skcServerOrderService;
    }

     /**
     * 获取平台服务
     * @private
     * @return SkcServerService
     */
    private _skcServerService: SkcServerService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerService(): SkcServerService
    {
        if(!this._skcServerService)
        {
            this._skcServerService = this.$serviceProvier.resolve<SkcServerService>(SkcServerService);
        }

        return this._skcServerService;
    }

     /**
     * 获取套餐名称
     * @protected
     */
    protected getDurationUnitTypeName(value: number):string
    {
        return EnumUtils.getEntry(value,DurationUnitType)?.alias || "";
    }

     /**
     * 获取订单状态名称
     * @protected
     */
    protected getOrderStateName(value: number):string
    {
        return EnumUtils.getEntry(value,ServerOrderStatusType)?.alias || "";
    }

    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 弹框显示
     * @protected
     * @returns 
     */
    protected visible: boolean = false;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 获取用户信息
     * @private
     * @return Promise<void>
     */
    private async getLoginInfo(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getLoginInfo();
            if(result.data)
            {
                // 存储登入所有信息
                this.$store.dispatch("user/setProfile", result.data);
            }
        } 
        catch(err)
        {
            
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }

    /**
     * table表单实例。
     * @protected
     * @returns any
     */
    public get $table(): any
    {
        return this.$refs.table as any;
    }
    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
       if (this.$route.query.id)
       {
           this.queryParam.OrderId = this.$route.query.id;
           this.$table.refresh();
       }
    }


    /**
     * 取消下单
     * @protected
     * @returns UserService
     */
    protected async cancelRow(row: IServerOrderModel): Promise<void>
    {
       try {
            let { content: res } = await this.skcServerOrderService.cancelOrder(row.id);
            this.$message.success("取消下单成功！");
            (this.$refs.table as any).refresh();
        } catch (err) {
            this.$message.error("取消下单失败！");
            (this.$refs.table as any).refresh();
        }
    }
    /**
     * 查询方法
     * @protected
     * @returns UserService
     */
    protected queryF(row: IServerOrderModel): void
    {
       delete this.queryParam.OrderId;
       (this.$refs.table as any).refresh();
    }
     /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    }
}
